var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",attrs:{"id":"app"}},[_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }